import { render } from "./PodsDetail.vue?vue&type=template&id=061effae"
import script from "./PodsDetail.vue?vue&type=script&lang=js"
export * from "./PodsDetail.vue?vue&type=script&lang=js"

import "./PodsDetail.vue?vue&type=style&index=0&id=061effae&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__